import { DataProtectionPolicyPage } from './DataProtectionPolicyPage';

export const DataProtectionPolicyTwPage = () => <DataProtectionPolicyPage page="portal.data.protectionPolicy.tw" />;
